import { useState } from "react";

import classNames from "classnames";
import cn from "./Feedback.module.css";

function Suggestion() {
  const [hasSubmitted, setSubmitted] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [comment, setComment] = useState(null);
  const [url, setURL] = useState(null);
  const kind = window.CSSMasterClass.suggestionKind;

  const INFO = {
    screencast: {
      placeholder: "Write about what you'd like me to teach you",
      more: "You can also link to a website for more information",
    },
    project: {
      placeholder: "Write about what kind of project you'd like me to build",
      more: "You can also link to a website you'd like me to reproduce",
    },
  };

  const handleCommentChange = (event) => {
    setComment(event.target.value);
  };

  const handleURLChange = (event) => {
    setURL(event.target.value);
  };

  const handleSubmit = async () => {
    if (hasSubmitted) {
      return;
    }

    setLoading(true);
    const csrfToken = document.querySelector("meta[name='csrf-token']");

    if (!csrfToken) {
      throw new Error("No token available.");
    }

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken.content,
      },
      credentials: "include", // Include cookies in the request,
      body: JSON.stringify({
        kind,
        comment,
        url,
      }),
    };

    try {
      const response = await fetch(`/api/suggestion`, options);

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      setSubmitted(true);
    } catch (error) {
      console.error("Error fetching data: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const componentCN = classNames({
    [cn.component]: true,
    [cn.suggestion]: true,
    [cn["submitted"]]: hasSubmitted,
  });

  return (
    <div className={componentCN}>
      <div className={cn.main}>
        <p>
          What <span>{kind}</span> would you like to suggest?
        </p>

        <textarea
          className="form-control"
          value={comment}
          required
          onChange={handleCommentChange}
          placeholder={INFO[kind].placeholder}
        />

        <small>{INFO[kind].more}</small>

        <input
          type="url"
          value={url}
          onChange={handleURLChange}
          className="form-control"
          placeholder="https://example.com"
        />

        <div className={cn.submit}>
          <button
            className="button is-primary"
            onClick={handleSubmit}
            disabled={isLoading || !comment}
          >
            <span className="button-label">Submit Suggestion</span>
          </button>
        </div>
      </div>

      <div className={cn.thanks}>Thank you for your suggestion!</div>
    </div>
  );
}

export default Suggestion;
